export default {
  BusinessStockDistributionQtyAddSku: {
    title: '仓位数量分配添加',
    supportWarehouseType: '供货仓类型:',
    supportWarehouseId: '供货仓名称:',
    receiveWarehouseType: '接收仓类型:',
    receiveWarehouseId: '接收仓名称:',
    // spuCode: '商品编码:',
    // spuName: '商品名称：',
    categoryId: '商品分类：',
    skuCode: 'SKU编码：',
    supplyWarehouseList: '供货仓商品列表',
    warehouseType: '仓库类型',
    realPosition: '实仓',
    warehouseCode: '仓库编码',
    warehouseName: '仓库名称',
    distribute: '分配',
    withdraw: '撤回',
    receivingWarehouseList: '接收仓商品列表',
    setQty: '批量设置',
    setQtyMsg1: '请选择 右侧 接收仓 商品',
    setQtyMsg2: '请输入仓位数量',
    setQtyMsg3: '批量设置仓位数量',
    inputErrorMsg: '数量格式不正确',
    errorMsg: '取消输入',
    msgWarning1: '请选择 左侧 供货仓 商品',
    msgWarning2: '请先选择商品',

    table: {
      categoryName: '商品分类',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      qty: '仓位数量'
    }
  }
};
